import Login from "./pages/Auth/Login";
import Home from "./pages/Home";
import { onAuthStateChanged } from "firebase/auth";
import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "./config/firebase";
import Users from "./pages/Users";
import Documents from "./pages/Documents";
import UserDetails from "./pages/UserDetails";
import ConfigPayments from "./pages/ConfigPayments";
import AppointmentsList from "./pages/AppointmentsList";
import AppointmentDetails from "./pages/AppointmentDetails";
import AvailabilitiesAdmin from "./pages/AvailabilitiesAdmin";
import NotificationsPage from "./pages/NotificationsPage";

function App() {
  const [authenticated, setAuthenticated] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const unsusbcribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
      }
      setLoaded(true);
    });
    return () => unsusbcribe();
  };

return authenticated ? (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/users" element={<Users />} />
    <Route path="/users/:id" element={<UserDetails />} />
    <Route path="/documents" element={<Documents />} />
    <Route path="/config" element={<ConfigPayments />} />
    <Route path="/rdv" element={<AppointmentsList />} />
    <Route path="/rdv/:id" element={<AppointmentDetails />} />
    <Route path="/disponibilités" element={<AvailabilitiesAdmin />} />
    <Route path="/notifications" element={<NotificationsPage />} />

    {/* Redirection pour pages inconnues */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
) : (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);
}

export default App;
